import React from "react";

const Input = ({ name, type, value, placeholder, onChange }) => {
	return (
		<>
			<input id={name} name={name} type={type} placeholder={placeholder} value={value} onChange={onChange} className="" />
		</>
	);
};

export default Input;
